import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import {ConnectionGroup, ConnectionGroupType} from './types';
import {Dictionary} from '@reduxjs/toolkit';
import {Connection, ConnectionUser, sortConnectionUsers} from '../../data';
import {byPropDesc, stringCompare} from '@lib/utils';

export const groupConnectedUsersByStatus = (connections: Dictionary<Connection>, connectedUsers: ConnectionUser[]) => {
  const getConnection = (conns: Dictionary<Connection>, connId?: string) => {
    return conns[connId ?? ''];
  };

  return map(
    groupBy(
      filter(connectedUsers, (user) => {
        const connection = getConnection(connections, user.connectionId);
        return !!connection && (connection.status === 'Accepted' || connection.status === 'Pending');
      }),
      (user): ConnectionGroupType => {
        const connection = getConnection(connections, user.connectionId) as Connection;
        return connection.status === 'Pending' && connection.direction === 'Incoming' ? 'PendingIncoming' : 'Connected';
      },
    ),
    (connUsers, key): ConnectionGroup => {
      return {
        key: key as ConnectionGroupType,
        data: connUsers.sort((u1, u2) => {
          const u1Connection = getConnection(connections, u1.connectionId) as Connection;
          const u2Connection = getConnection(connections, u2.connectionId) as Connection;

          if (u1Connection.status !== u2Connection.status) {
            return stringCompare(u1Connection.status, u2Connection.status);
          }

          return sortConnectionUsers(u1, u2);
        }),
      };
    },
  ).sort(byPropDesc('key'));
};
